import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { ActionPlansContext } from "context/ActionPlansContext";
import UserService from "services/UserService";
import { putActionPlan, getActionPlan } from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  AutocompleteInput,
  CustomSelect,
  CustomSwitch,
  DateInput,
  FloatInput,
  IntInput,
  LocalizationAutocomplete,
  TextInput,
} from "components/Input/Index.js";
import EditButton from "components/CustomButtons/EditButton";
import { planActions } from "variables/planActions";
import { reclevelData } from "variables/lists/planActions";

const priorityData = [
  { id: "1", name: "1" },
  { id: "2", name: "2" },
  { id: "3", name: "3" },
];

export default function CharacteristicsEdit({ apiData, params, closeModal }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanadmin = permis.includes("actionplan_admin");
  const appContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = appContext;

  const [newCharacteristics, setNewCharacteristics] = useState();

  // console.log(actionPlans);
  // console.log(params, newCharacteristics, newCharacteristics[params]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    //console.log(e.target);
    setNewCharacteristics((prevState) => ({
      ...prevState,
      [params]: { ...prevState.characteristics, [name]: value },
    }));
  };

  useEffect(() => {
    //setNewCharacteristics({ actionplan: actionPlans.id });
    //console.log("actionPlans");
    setNewCharacteristics(actionPlans?.parameters || {});
  }, [actionPlans]);

  const urlPlanAction = getActionPlan(actionPlans.id);

  let url = putActionPlan(actionPlans.id);

  const handleSubmit = (event) => {
    createActionCharacteristics(event);
    //setLoading(true);
    // axios
    //   .get(urlPlanAction, {
    //     method: "GET",
    //     headers: {
    //       Authorization: `Bearer ${UserService.getToken()}`,
    //     },
    //   })
    //   .then((response) => {
    //    // console.log(response.data);
    //     setActionPlans(response.data || []);
    //   });
  };

  const createActionCharacteristics = async (event) => {
    //console.log(newCharacteristics);

    axios
      .put(url, newCharacteristics, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          'Content-Type': "application/json; charset=utf-8",
        },
      })
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          setActionPlans((prevState) => ({
            ...prevState,
            parameters: newCharacteristics,
          }));
          setNotification("success", "Caractéristiques modifiée");
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <CustomSelect
            inputTitle={planActions[params]["reclevel"]}
            selectValue={newCharacteristics?.[params]?.["reclevel"] || ""}
            handleSelectValueChange={handleChange}
            data={reclevelData}
            name="reclevel"
            disabled={!actionplanadmin}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6} lg={6}>
          <TextInput
            inputTitle={planActions[params]["grade"]}
            textInput={newCharacteristics?.[params]?.["grade"] || ""}
            handleTextInputChange={handleChange}
            name="grade"
            disabled={!actionplanadmin}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6}>
          <CustomSelect
            inputTitle={planActions[params]["priority"]}
            selectValue={newCharacteristics?.[params]?.["priority"] || ""}
            handleSelectValueChange={handleChange}
            data={priorityData}
            name="priority"
            disabled={!actionplanadmin}
          />
        </GridItem>
      </GridContainer>
      {actionplanadmin && (
        <GridContainer>
          <GridItem
            xs={12}
            sm={6}
            md={7}
            lg={7}
            style={{ marginLeft: "8px", marginTop: "12px" }}
          >
            <EditButton handleSubmit={handleSubmit}>Modifier</EditButton>
          </GridItem>
        </GridContainer>
      )}
    </>
  );
}
